export default "__VITE_ASSET__d5b7a9e6__$_?nuxt_component=async&nuxt_component_name=SvgoHelp2952990__"